var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { action, observable, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import { Aspect_ } from '../../../../components/actor/Aspect_';
let AbfragerBottomButton = class AbfragerBottomButton extends React.PureComponent {
    isHovering = false;
    isActive = false;
    constructor(props) {
        super(props);
        makeObservable(this);
    }
    render() {
        const { typ, style, aspect, children, ...passProps } = this.props;
        const button = (React.createElement("span", { style: {
                ...styles.base,
                ...styles[`typ${typ}`],
                ...style,
                ...(this.isHovering ? styles.base_hover : {}),
                ...(this.isActive ? styles.base_active : {})
            }, ...passProps, onMouseEnter: action(() => (this.isHovering = true)), onMouseLeave: action(() => (this.isHovering = false)), onMouseDown: action(() => (this.isActive = true)), onMouseUp: action(() => (this.isActive = false)) }, children));
        if (aspect) {
            return (React.createElement(Aspect_, { aspect: aspect, templateComponent: button }, children));
        }
        return button;
    }
};
__decorate([
    observable
], AbfragerBottomButton.prototype, "isHovering", void 0);
__decorate([
    observable
], AbfragerBottomButton.prototype, "isActive", void 0);
AbfragerBottomButton = __decorate([
    observer
], AbfragerBottomButton);
export { AbfragerBottomButton };
const styles = {
    base: {
        flex: '0 1 auto',
        background: 'linear-gradient(to bottom,  rgba(228,228,228,0.4) 0%,rgba(174,174,174,0.4) 100%)',
        height: 26,
        color: '#555',
        fontSize: 14,
        fontWeight: 'bold',
        display: 'inline-block',
        borderTop: '1px solid rgba(150,150,150,0.1)',
        padding: '2px 12px 1px 12px',
        textDecoration: 'none',
        cursor: 'pointer',
        whiteSpace: 'nowrap'
    },
    base_hover: {
        background: 'linear-gradient(to bottom, rgba(228,228,228,0.58) 0%,rgba(174,174,174,0.58) 100%)'
    },
    base_active: {
        background: 'linear-gradient(to bottom, rgba(228,228,228,0.58) 0%,rgba(174,174,174,0.58) 100%)',
        position: 'relative',
        top: 1
    },
    typ0: {
        borderBottomRightRadius: 10,
        borderLeft: '1px solid rgba(120, 120, 120, 0.3)'
    },
    typ1: {
        borderTopLeftRadius: 10,
        borderLeft: '1px solid rgba(150,150,150,0.1)'
    },
    typ2: {
        borderTopRightRadius: 10,
        borderRight: '1px solid rgba(120,120,120,0.3)'
    },
    typ3: {
        borderTopLeftRadius: 10,
        borderBottomRightRadius: 10,
        borderLeft: '1px solid rgba(150,150,150,0.1)'
    },
    typ4: {
        borderBottomLeftRadius: 10
    },
    typ5: {
        borderTopRightRadius: 10,
        borderRight: '1px solid rgba(120, 120, 120, 0.3)',
        borderLeft: '1px solid rgba(120, 120, 120, 0.3)'
    }
};
